// extracted by mini-css-extract-plugin
export default {"emptyState":"EmptyState_emptyState__u7+Us","addBtn":"EmptyState_addBtn__EWSa6"};